import { atom } from "recoil";

/**
 * Logged in user id
 */
export const systemModelStructureDirtyState = atom<boolean>({
  key: "systemModelStructureDirtyState",
  default: false,
});
